import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubblePlus: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBubblePlus"><Path fillRule="evenodd" clipRule="evenodd" d="M21.002 3V19.0357L15.3757 19.0358L11.9939 21.8375L8.65157 19.0358H3.00195V3.00003L21.002 3ZM12.9998 7L10.9998 7L10.9998 9.99997H7.99976V12H10.9998V15H12.9998V12H15.9998V9.99997H12.9998L12.9998 7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubblePlus;
